import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Grid, Checkbox, TablePagination } from "@mui/material";
import "./ProductionLine.css";
import { getBatchStrip } from "../AddBatch/services";
import {
  assignBatchStripping,
  getAssignToStrippingBatchList,
} from "./services";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";

const ProductionLineStripping = () => {
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [count, setCount] = useState();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const navigate = useNavigate();
  const { userPermission } = useSelector((state) => state.userState);
  const location = useLocation();

  const manualBatch = location?.state?.manualBatch;
  const isautobatch = location?.state?.isautobatch;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const hasAutoAddBatch = () => {
    if (!isautobatch) return false; // Only check for auto-add batches if isautobatch is true
    return selectedBatches.some((batchId) => {
      const batch = batchData.find((b) => b.batchid === batchId);
      return batch?.is_auto_add;
    });
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleBatchSelect = (batchId) => {
    setSelectedBatches(
      (prev) =>
        prev.includes(batchId)
          ? prev.filter((id) => id !== batchId) // Remove if already selected
          : [...prev, batchId] // Add if not selected
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const productionLinePermission = userPermission.find(
      (permission) => permission.module === "Production Line"
    );

    if (
      !productionLinePermission?.is_editor ||
      !productionLinePermission?.is_viewer
    ) {
      toast.error("You don't have access");
      return;
    }
    if (selectedBatches.length === 0) {
      toast.error("Please select at least one batch.");
      return;
    }

    try {
      const params = {
        batch_id: selectedBatches,
        is_manual_batch: manualBatch,
      };

      const resp = await assignBatchStripping(params);
      if (resp.status === 200 || resp.status === 201) {
        toast.success(resp.data.message);
        console.log("stationNamevvgdf", resp?.data?.payload?.station_name);
        const batchId = selectedBatches.join(",");

        navigate(`/production-line-chart`, {
          state: {
            batch_types: batchId,
            stationName: resp?.data?.payload?.station_name,
          },
        });

        console.log("Navigation should have occurred.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      console.error("HandleSubmit Error:", error);
    }
  };

  useEffect(() => {
    const handleBatchData = async () => {
      try {
        const resp = await getAssignToStrippingBatchList(page, rowsPerPage);
        if (resp.status === 200 || resp.status === 201) {
          const data = resp.data.results || [];
          setCount(resp.data.count);

          setBatchData(data);
        }
      } catch (error) {
        setBatchData([]);
        toast.error("Failed to fetch batch data.");
        console.error("handleBatchData Error:", error);
      }
    };

    handleBatchData();
  }, [page, rowsPerPage]);

  return (
    <div className="min-h-screen bg-[#f5f3ff] p-8 dashboard-wrapper page-wraper">
      <ToastContainer />
      <div className="page-header">
        <Link to="/dashboard" className="page-back-btn">
          <ArrowBackIcon />
          <span>Production Line</span>
        </Link>
      </div>

      {/* Grid Layout */}
      <div className="production-line-stripping">
        <Grid container spacing={2}>
          {/* Batch Numbers Column */}
          <Grid item xs={3}>
            <div className="batch-column">
              <h3>Batch No</h3>
              <div className="batch-item">
                {batchData.map((batch, index) => (
                  <div key={index} className="batch-items">
                    <Checkbox
                      checked={selectedBatches.includes(batch.batchid)}
                      onClick={() => handleBatchSelect(batch.batchid)}
                      sx={{
                        color: "#1C407B",
                        "&.Mui-checked": { color: "#1C407B" },
                      }}
                    />
                    <span
                      style={{
                        fontWeight: selectedBatches.includes(batch.batchid)
                          ? "700"
                          : "",
                      }}
                    >
                      {batch.batch_type}
                    </span>
                  </div>
                ))}
              </div>
              <TablePagination
                className="table-pagination"
                rowsPerPageOptions={[20, 50, 100]}
                component="div"
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </Grid>

          {/* UID Column */}
          <Grid item xs={9}>
            <div className="uid-column">
              <h3>UID</h3>
              <div className="uid-item">
                <div className="uid-items">
                  {selectedBatches.flatMap(
                    (batchId) =>
                      batchData
                        .find((batch) => batch.batchid === batchId)
                        ?.batch_id?.map((uid, index) => (
                          <div
                            key={`${batchId}-${index}`}
                            className="uid-items-each"
                          >
                            {uid.uid_id_type}
                          </div>
                        )) || []
                  )}
                </div>
                <div className="assign-btn-container">
                  <button
                    className="assign-button"
                    onClick={handleSubmit}
                    disabled={isautobatch ? hasAutoAddBatch() : false} // Only apply hasAutoAddBatch check if isautobatch is true
                    style={{
                      opacity: isautobatch && hasAutoAddBatch() ? 0.5 : 1,
                      cursor:
                        isautobatch && hasAutoAddBatch()
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    Assign
                  </button>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ProductionLineStripping;
